import { observer } from 'mobx-react-lite';
import { CSSProperties, useMemo } from 'react';
import { CountdownTimer } from '../model/countdown-timer';
import { PropsBase } from '../model/props-base';

interface countdownProps extends PropsBase {
    endTime: number;
}

const smaller: CSSProperties = {
    fontSize: '65%'
};

export const Countdown = observer((props: countdownProps) => {

    const timer: CountdownTimer = useMemo(() => {
        const end = new Date(props.endTime);
        const t = new CountdownTimer(end);
        t.start();
        return t;
    }, [props.endTime]);

    function formatDisplayValue(value: number) {
        return value.toFixed(0).toString().padStart(2, '0');
    }

    return (
        <div style={props.style} className={props.className}>
            <span>{formatDisplayValue(timer.hours)}</span>
            <span style={smaller}>H</span>
            <span>{formatDisplayValue(timer.minutes)}</span>
            <span style={smaller}>M</span>
            <span>{formatDisplayValue(timer.seconds)}</span>
            <span style={smaller}>S</span>
        </div>
    );
});